'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var index = require('../../providers/ClaimBuilder/index.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var SelectableCardActionChips = require('../../components/SelectableCardActionChips.js');
var SessionContext = require('../../providers/SessionContext.js');
var useAnalytics = require('../../providers/useAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const ItemSelectionCardActions = _ref => {
  var _claimDetails$photos;
  let {
    claimDetails,
    packageId
  } = _ref;
  const {
    state: {
      itemClaims,
      claimType
    },
    handleItemClaimSelection
  } = index.useClaimBuilder();
  const {
    claimsChipComment,
    claimsChipCommentIconAccessibleTextComplete,
    claimsChipCommentIconAccessibleTextIncomplete,
    claimsChipPhoto,
    claimsChipPhotoIconAccessibleTextComplete,
    claimsChipPhotoIconAccessibleTextIncomplete,
    claimsChipQuantity,
    claimsChipQuantityIconAccessibleTextComplete,
    claimsChipQuantityIconAccessibleTextIncomplete
  } = nthHookTranslations.useTranslations();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const itemClaimSteps = itemClaims[`${claimDetails.uid}_${claimDetails.packageId}`].claimSteps;
  const claimDetailChipMap = {
    [index.ClaimStepId.QUANTITY]: {
      label: claimsChipQuantity ?? '',
      isComplete: Boolean(claimDetails.quantity),
      statusConfigs: {
        complete: {
          icon: /*#__PURE__*/React__default["default"].createElement("span", {
            "aria-label": mustache__default["default"].render(claimsChipQuantityIconAccessibleTextComplete ?? '', {
              quantity: claimDetails.quantity
            }) ?? undefined
          }, claimDetails.quantity) ?? ''
        },
        incomplete: {
          iconLabel: claimsChipQuantityIconAccessibleTextIncomplete ?? ''
        }
      }
    },
    [index.ClaimStepId.PHOTOS]: {
      label: claimsChipPhoto ?? '',
      isComplete: Boolean((_claimDetails$photos = claimDetails.photos) === null || _claimDetails$photos === void 0 ? void 0 : _claimDetails$photos.length),
      statusConfigs: {
        complete: {
          iconLabel: claimsChipPhotoIconAccessibleTextComplete ?? ''
        },
        incomplete: {
          iconLabel: claimsChipPhotoIconAccessibleTextIncomplete ?? ''
        }
      }
    },
    [index.ClaimStepId.ADDITIONAL_INFO]: {
      label: claimsChipComment ?? '',
      isComplete: Boolean(claimDetails === null || claimDetails === void 0 ? void 0 : claimDetails.additionalInfo.comment),
      statusConfigs: {
        complete: {
          iconLabel: claimsChipCommentIconAccessibleTextComplete ?? ''
        },
        incomplete: {
          iconLabel: claimsChipCommentIconAccessibleTextIncomplete ?? ''
        }
      }
    }
  };
  const onActionChipClick = id => {
    // Check if it is Adding comment step
    if (id === index.ClaimStepId.ADDITIONAL_INFO && !claimDetails.additionalInfo.comment) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ADD_COMMENT,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_SELECTION,
        page_step: useAnalytics.ClaimsPageStep.SELECTION,
        order_number: orderNumber,
        claim_reason: claimType
      });
    }
    handleItemClaimSelection({
      itemUid: claimDetails.uid,
      step: id,
      packageId
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(SelectableCardActionChips.ActionChipsContainer, null, itemClaimSteps.map(_ref2 => {
    let {
      id
    } = _ref2;
    return /*#__PURE__*/React__default["default"].createElement(SelectableCardActionChips.ActionChip, {
      key: id,
      onClick: () => onActionChipClick(id),
      isComplete: claimDetailChipMap[id].isComplete,
      statusConfigs: claimDetailChipMap[id].statusConfigs,
      label: claimDetailChipMap[id].label
    });
  }));
};
var ItemSelectionCardActions$1 = nthHookTranslations.withTranslationsProvider(ItemSelectionCardActions, {
  translationKeys: ['claimsChipComment', 'claimsChipCommentIconAccessibleTextComplete', 'claimsChipCommentIconAccessibleTextIncomplete', 'claimsChipPhoto', 'claimsChipPhotoIconAccessibleTextComplete', 'claimsChipPhotoIconAccessibleTextIncomplete', 'claimsChipQuantity', 'claimsChipQuantityIconAccessibleTextComplete', 'claimsChipQuantityIconAccessibleTextIncomplete']
});

exports["default"] = ItemSelectionCardActions$1;
